export default __webpack_public_path__ + "static/illustration-p4-b1499e0d6caf489756d225f2020599ed.gif";